import { createApiRequest } from "@/lib/api/createApiService";
import { CALL_FOR_HELP_ENDPOINTS } from "./call-for-help.endpoints";
import apiClient from "@/lib/api/client";
const downloadBlob = ({ data, filename }) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const callForHelpService = {
  submitCallForHelp: async (payload, options = {}) => {
    return createApiRequest({
      url: CALL_FOR_HELP_ENDPOINTS.SUBMIT,
      method: "POST",
      body: payload,
      ...options,
    });
  },
  getSurveys: async (options = {}) => {
    return createApiRequest({
      url: CALL_FOR_HELP_ENDPOINTS.GETSURVEYS,
      method: "GET",
      ...options,
    });
  },
  uploadAttachment: async (companyId, files, options = {}) => {
    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }
    return createApiRequest({
      url: CALL_FOR_HELP_ENDPOINTS.UPLOAD_ATTACHMENT(companyId),
      method: "POST",
      body: formData,
      isFormData: true,
      ...options,
    });
  },

  deleteAttachment: async (fileId, options = {}) => {
    return createApiRequest({
      url: CALL_FOR_HELP_ENDPOINTS.DELETE_ATTACHMENT(fileId),
      method: "DELETE",
      ...options,
    });
  },
  downloadAttachment: async (proof) => {
    const fileId = proof?.fileId || proof?._id;
    if (!fileId) return;
    const { data } = await apiClient.get(`/files/download/${fileId}`, {
      responseType: "blob",
    });
    downloadBlob({
      data,
      filename: proof.name || proof.originalName || "download",
    });
  },
  downloadAttachmentForFileId: async (proof) => {
    const fileId = proof?.fileId || proof?._id;
    if (!fileId) return;
    const { data } = await apiClient.get(`/files/download/file/${fileId}`, {
      responseType: "blob",
    });
    downloadBlob({
      data,
      filename: proof.name || proof.originalName || "download",
    });
  },
};
